// Breadcrumb identifiers
const compensationRateBreadcrumbIdentifier = {
    route: 'tools.partners.partner-compensation-rates.edit',
    parameterLabel: 'partner_compensation_rate',
    parameters: ['partner_compensation_rate']
}

const manualInvoiceIdentifier = {
    route: 'tools.manual-invoice-uploads.show',
    parameterLabel: 'manualInvoiceUpload',
    parameters: ['manualInvoiceUpload']
}
export default ($page) => {
    return [
        {
            route: 'tools.invoices.index',
            label: 'messages.sitemap.tools.invoices.invoices',
            showInSidebar: true,
            permissions: ['invoice.manage'],
            id: 'billing-and-accounting-invoices-index'
        },
        {
            route: '',
            label: 'messages.sitemap.tools.manual_invoices.manual_invoices',
            showSecondDropdown: true,
            showInSidebar: true,
            sidebarItemName: 'manualInvoices',
            permissions: ['contract.partners', 'providerbox.import'],
            id: 'manual-invoices-menu',
            children: [
                {
                    route: 'tools.partners.partner-compensation-rates.index',
                    label: 'messages.sitemap.tools.partners.partners',
                    showInSidebar: true,
                    permissions: ['contract.partners'],
                    id: 'billing-and-accounting-partner-compensation-rates-index',
                    children: [
                        {
                            route: 'tools.partners.partner-compensation-rates.create',
                            label: 'messages.sitemap.tools.partners.compensation_rates.create'
                        },
                        {
                            route: 'tools.partners.partner-compensation-rates.edit',
                            label: 'messages.sitemap.tools.partners.compensation_rates.edit',
                            identifier: compensationRateBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'tools.partners.partner-uploads.index',
                    label: 'messages.sitemap.tools.partners.partners',
                    activeSidebarRoute: 'tools.partners.partner-compensation-rates.index',
                    permissions: ['contract.partners'],
                    id: 'billing-and-accounting-partner-upload-index'
                },
                {
                    route: 'tools.partners.contracts.index',
                    label: 'messages.sitemap.tools.partners.partners',
                    activeSidebarRoute: 'tools.partners.partner-compensation-rates.index',
                    permissions: ['contract.partners']
                },
                {
                    route: 'tools.providerbox.import-index',
                    label: 'messages.sitemap.tools.providerbox.providerbox',
                    showInSidebar: true,
                    activeSidebarRoute: 'tools.providerbox.import-index',
                    permissions: ['providerbox.import'],
                    id: 'billing-and-accounting-providerbox-index'
                },
                {
                    route: 'tools.providerbox.imported-items',
                    label: 'messages.sitemap.tools.providerbox.imported_items',
                    activeSidebarRoute: 'tools.providerbox.import-index',
                    permissions: ['providerbox.import'],
                    id: 'billing-and-accounting-providerbox-imported-items'
                },
                {
                    route: 'tools.providerbox.invoices-index',
                    label: 'messages.sitemap.tools.providerbox.invoices',
                    activeSidebarRoute: 'tools.providerbox.import-index',
                    permissions: ['providerbox.import'],
                    id: 'billing-and-accounting-providerbox-invoices'
                },
                {
                    route: 'tools.manual-invoice-uploads.index',
                    label: 'messages.sitemap.tools.invoice_uploads.index',
                    showInSidebar: true,
                    activeSidebarRoute: 'tools.manual-invoice-uploads.index',
                    permissions: ['billing_and_accounting.manual_invoice_uploads'],
                    id: 'billing-and-accounting-manual-invoice-uploads',
                    children: [
                        {
                            route: 'tools.manual-invoice-uploads.show',
                            label: 'messages.sitemap.tools.invoice_uploads.show',
                            identifier: manualInvoiceIdentifier,
                            showInSidebar: false,
                            permissions: ['billing_and_accounting.manual_invoice_uploads'],
                            id: 'billing-and-accounting-manual-invoice-show'
                        },
                        {
                            route: 'tools.manual-invoice-uploads.upload',
                            label: 'messages.sitemap.tools.invoice_uploads.upload',
                            showInSidebar: false,
                            permissions: ['billing_and_accounting.manual_invoice_uploads'],
                            id: 'billing-and-accounting-manual-invoice-upload'
                        },
                        {
                            route: 'tools.manual-invoice-uploads.preview',
                            identifier: manualInvoiceIdentifier,
                            label: 'messages.sitemap.tools.invoice_uploads.preview',
                            showInSidebar: false,
                            permissions: ['billing_and_accounting.manual_invoice_uploads'],
                            id: 'billing-and-accounting-manual-invoice-preview'
                        }
                    ]
                }
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.tools.dunning.dunning',
            showInSidebar: true,
            permissions: ['dunning.manage', 'dunning.collection'],
            showSecondDropdown: true,
            sidebarItemName: 'dunning',
            id: 'billing-and-accounting-dunning',
            children: [
                {
                    route: 'tools.dunning.index',
                    label: 'messages.sitemap.tools.dunning_letter.dunning_letter',
                    showInSidebar: true,
                    permissions: ['dunning.manage'],
                    id: 'billing-and-accounting-dunning-letters-index'
                },
                ...($page.props.isCollectionHandoverSupported
                    ? [
                        {
                            route: 'tools.collection.national',
                            label: 'messages.sitemap.tools.collection.collection',
                            showInSidebar: true,
                            permissions: ['dunning.collection'],
                            id: 'billing-and-accounting-collection-index'
                        },
                        {
                            route: 'tools.collection.foreign',
                            label: 'messages.sitemap.tools.collection.collection',
                            activeSidebarRoute: 'tools.collection.national',
                            permissions: ['dunning.collection']
                        },
                        {
                            route: 'tools.collection.history',
                            label: 'messages.sitemap.tools.collection.collection',
                            activeSidebarRoute: 'tools.collection.national',
                            permissions: ['dunning.collection']
                        },
                        {
                            route: 'tools.collection.batches',
                            label: 'messages.sitemap.tools.collection.collection',
                            activeSidebarRoute: 'tools.collection.national',
                            permissions: ['dunning.collection'],
                            id: 'billing-and-accounting-batches'
                        },
                        {
                            route: 'tools.collection.show',
                            label: 'messages.sitemap.tools.collection.collection',
                            activeSidebarRoute: 'tools.collection.national',
                            permissions: ['dunning.collection'],
                            id: 'billing-and-accounting-batches-show'
                        },
                        {
                            route: 'tools.in-collection.index',
                            label: 'messages.sitemap.tools.in-collection.in-collection',
                            showInSidebar: true,
                            permissions: ['dunning.collection'],
                            id: 'billing-and-accounting-in-collection-index'
                        },
                        {
                            route: 'tools.in-lawsuit.index',
                            label: 'messages.sitemap.tools.in_lawsuit.in_lawsuit',
                            showInSidebar: true,
                            permissions: ['dunning.collection'],
                            id: 'billing-and-accounting-in-lawsuit-index'
                        }
                    ]
                    : []
                ),
                ...($page.props.isInDebtLossSupported
                    ? [
                        {
                            route: 'tools.debtloss-invoices',
                            label: 'messages.sitemap.tools.debt_loss.debt_loss',
                            showInSidebar: true,
                            permissions: ['dunning.collection'],
                            id: 'debtloss-invoices-index'
                        }
                    ]
                    : []
                )
            ]
        },
        {
            route: 'tools.sepa.transactions',
            label: 'messages.sitemap.tools.sepa.sepa_transactions',
            showInSidebar: true,
            permissions: ['payment.sepa'],
            id: 'billing-and-accounting-sepa-transactions'
        },
        {
            route: 'tools.credit-card.transactions',
            label: 'messages.sitemap.tools.credit_cards.credit_card_payments',
            showInSidebar: true,
            permissions: ['payment.credit_card'],
            id: 'billing-and-accounting-credit-card-transactions-index'
        },
        {
            route: 'tools.bankruptcy-monitor.index',
            label: 'messages.sitemap.tools.bankruptcy_monitor.bankruptcy_monitor',
            showInSidebar: true,
            permissions: ['billing_and_accounting.bankruptcy_monitor'],
            id: 'billing-and-accounting-bankruptcy-monitor-index',
            children: [
                {
                    route: 'tools.bankruptcy-monitor.history',
                    label: 'messages.sitemap.tools.bankruptcy_monitor.history',
                    showInSidebar: false,
                    permissions: ['billing_and_accounting.bankruptcy_monitor'],
                    id: 'billing-and-accounting-bankruptcy-monitor-history'
                }
            ]
        },
        {
            route: 'tools.customer-balances.index',
            label: 'messages.sitemap.tools.customer_balances.customer_balances',
            showInSidebar: true,
            permissions: ['billing_and_accounting.customer_balances'],
            id: 'billing-and-accounting-customer-balances-index'
        }
    ]
}
